import { NgModule } from '@angular/core';
import { ISBreadcrumbModule } from './is-breadcrumb/is-breadcrumb.module';
import { ISDateTimePickerModule } from './is-date-time-picker/is-date-time-picker.module';
import { ISFormLayoutModule } from './is-form-layout/is-form-layout.module';
import { ISMultiSelectModule } from './is-multi-select/is-multi-select.module';
import { ISSelectModule } from './is-select/is-select.module';
import { ISTableModule } from './is-table/is-table.module';
import { ISDialogModule } from './is-dialog/is-dialog.module';
import { ISProgressBarModule } from './is-progress-bar/is-progress-bar.module';
import { ISTabLayoutModule } from './is-tab-layout/is-tab-layout.module';
import { ISMessengerModule } from './is-messenger/is-messenger.module';
import { ISFileUploadModule } from './is-files-upload/is-files-upload.module';
import { InvoiceManagerModule } from './invoice-manager/invoice-manager.module';
import { ConsumptionsModule } from './consumptions/consumptions.module';
import { SharedModule } from './shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { ISFiltersModule } from './is-filters/is-filters.module';
import { EmptyCheckPipe } from './pipes/emptyCheck.pipe';
import './common/global-extensions'
import { ISInvoiceProcessorModule } from './is-invoice-processor/invoice-processor.module';
import { HideTextPipe } from './pipes/hide-text.pipe';
import { ISChipSetModule } from './is-chipset/is-chipset.module';
import { MVTableModule } from './mv-table/mv-table.module';
import { ISChartModule } from './is-chart/is-chart.module';
import { DateRangePipe } from './pipes/dateRange.pipe';

@NgModule({
  declarations: [
  ],
  imports: [
    ISTableModule,
    ISSelectModule,
    ISMultiSelectModule,
    ISBreadcrumbModule,
    ISDateTimePickerModule,
    ISFormLayoutModule,
    ISDialogModule,
    ISTabLayoutModule,
    ISProgressBarModule,
    ISMessengerModule,
    ISFileUploadModule,
    InvoiceManagerModule,
    ConsumptionsModule,
    SharedModule,
    TranslateModule,
    ISFiltersModule,
    ISInvoiceProcessorModule,
    ISChartModule,
    ISChipSetModule,
    MVTableModule
  ],
  exports: [
    EmptyCheckPipe,
    DateRangePipe,
    HideTextPipe
  ],
  entryComponents: [ISDialogModule],
  providers: [
  ]
})
export class ISLibModule { }
